import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { CollapsingContainer } from '../app-listing/collapsing-container';
import UserList from './user-list';
import { FormattedMessage, injectIntl } from 'react-intl';

const AttendeeList = ({ attendees = {}, pendingAttendees = [], isUserGuest = false }) => {
  const attendeesGoing = _.filter(attendees, { rsvp: 'going' });
  const attendeesNotGoing = _.filter(attendees, { rsvp: 'not_going' });
  const isPendingGreaterThanGoing = pendingAttendees.length > attendeesGoing.length;
  const pendingStyle = isPendingGreaterThanGoing ? { order: -1 } : {};

  return (
    <div className="AttendeeList">
      <CollapsingContainer
        className="flex"
        collapsedHeight={284}
        showText={ <FormattedMessage id="invite.attendee_list.see_all" defaultMessage="See All" /> }
        hideText={ <FormattedMessage id="invite.attendee_list.hide" defaultMessage="Hide" /> }
      >
        <div className="attending" data-testing-id="attending">
          <h6 className="no-top-margin">
            <FormattedMessage
              id="invite.attendee_list.length_attending"
              defaultMessage="{length} attending"
              values={{
                length: attendeesGoing.length
              }}
            />
          </h6>

          <UserList users={attendeesGoing} keyPrefix="going-" />
        </div>

        <div className="not-attending" data-testing-id="not-attending">
          <h6 className="no-top-margin">
            <FormattedMessage
              id="invite.attendee_list.not_attending"
              defaultMessage="{length} not attending"
              values={{
                length: attendeesNotGoing.length
              }}
            />
          </h6>

          <UserList users={attendeesNotGoing} keyPrefix="not-going-" />
        </div>

        { isUserGuest &&
          <div className="pending" style={pendingStyle} data-testing-id="pending">
            <h6 className="no-top-margin">
              <FormattedMessage
                id="invite.attendee_list.pending"
                defaultMessage="{length} pending"
                values={{
                  length: pendingAttendees.length
                }}
              />
            </h6>

            <UserList users={pendingAttendees} keyPrefix="pending-" />
          </div>
        }
      </CollapsingContainer>
    </div>
  );
};

AttendeeList.propTypes = {
  attendees: PropTypes.object,
  pendingAttendees: PropTypes.array,
  isUserGuest: PropTypes.bool
};

export default injectIntl(AttendeeList);
